define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function renderPaging($paging) {
        $paging.text(parseInt($paging.data('cur')) + 1 + " of " + parseInt($paging.data('total')));
        var empty = parseInt($paging.data('total')) === 0;
        if (empty) {
            $paging.attr('empty', 'empty');
        }
        else {
            $paging.removeAttr('empty');
        }
    }
    exports.renderPaging = renderPaging;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/controls/paging-info.js
// module id = 16
// module chunks = 0